import React from "react"
import Home from "./Home"

function Maintenance() {
    return (
        <div style={{ fontFamily: `JohnsonText',sans-serif'`, fontSize: '14px',background: 'white' }}>
            <div style={{ textAlign: 'center', width: '700' }}>
                <div>
                <img src="images/idiscover_logo_spinning.gif" width="240" height="240" />
                <img src="images/idiscover_mdm_logo.png" width="310" />
                </div>
                <div>
                <img src="images/maintenance_message.png" width="834" />
                </div>
            </div>
        </div>
    )
}

export default Maintenance;